import { createElement, useEffect, useRef, useState } from 'react'

export default function CloneNode({
  selector,
  className,
  as = 'div',
}: {
  selector: string
  className?: string
  as?: 'div' | 'h5'
}) {
  const ref = useRef<HTMLElement>(null)
  const [contentState, setContentState] = useState<string | null>(null)

  useEffect(() => {
    if (ref.current) {
      const element: HTMLDivElement | null = document.querySelector(selector)
      ref.current.innerHTML = element?.innerHTML ?? ''

      setContentState((element?.innerHTML ?? '').trim())
    }
  }, [ref, selector])

  return createElement(as, { ref, className: contentState ? className : '' })
}
